import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageProvider } from '../../services/localStorage';
import { KYC_REVIEW_STATUS, KYC_STATUS } from '../constants/eventsConstant';

export const PostAuthGuard = () => {
  const localStorage = inject(LocalStorageProvider);
  const router = inject(Router);
  let userInfo = localStorage.getItem('userInfo');

  let isAuthenticated =
    (localStorage.getItem('refreshToken') &&
      userInfo.kyc_review_status === KYC_REVIEW_STATUS.completed &&
      userInfo.kyc_status === KYC_STATUS.Approved) ||
    false;
  if (!isAuthenticated) {
    localStorage.clearAll();
    router.navigate(['/']);
  }
  return isAuthenticated;
};
